const firebase = require('firebase');
require('firebase/firestore');

var firebaseConfig = {
  apiKey: 'AIzaSyCAJGWfMhVU6gQCKmuJtHXR5E421f0M7zY',
  authDomain: 'vimix-store.firebaseapp.com',
  databaseURL: 'https://vimix-store.firebaseio.com',
  projectId: 'vimix-store',
  storageBucket: 'vimix-store.appspot.com',
  messagingSenderId: '863933937895',
  appId: '1:863933937895:web:5e0d00981109f0e11c8a42',
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase;
